import { Routes } from '@angular/router';
import { ActionNeededComponent } from 'app/actionneeded/actionneeded.component';
import { BoardRequestsComponent } from 'app/boardrequests/boardrequests.component';
import { CabinetMembersComponent } from 'app/cabinetmembers/cabinetmembers.component';
import { CabinetUnassignedComponent } from 'app/cabinetunassigned/cabinetunassigned.component';
import { CategoriesComponent } from 'app/categories/categories.component';
import { CreateComponent } from 'app/create/create.component';
import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { EditRequestComponent } from 'app/editrequest/editrequest.component';
import { EmailPreferencesComponent } from 'app/emailpreferences/emailpreferences.component';
import { FacilitatorsComponent } from 'app/facilitators/facilitators.component';
import { HandleRequestComponent } from 'app/handlerequest/handlerequest.component';
import { HomeComponent } from 'app/home/home.component';
import { LoginComponent } from 'app/login/login.component';
import { OfflineComponent } from 'app/offline/offline.component';
import { OutOfOfficeComponent } from 'app/outofoffice/outofoffice.component';
import { OtherRequestsComponent } from 'app/otherrequests/otherrequests.component';
import { ReferralsComponent } from 'app/referrals/referrals.component';
import { RequestsComponent } from 'app/requests/requests.component';
import { SearchComponent } from 'app/search/search.component';
import { ViewRequestComponent } from 'app/viewrequest/viewrequest.component';
import { UnsavedChangesGuard, AuthenticatedGuard } from 'routes/routes.guard';
import { BoardAssistantsComponent } from 'app/boardassistants/boardassistants.component';
var ɵ0 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent', 'Cabinet', 'Responder', 'Facilitator'] }, ɵ1 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ2 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ3 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ4 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ5 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ6 = { roles: ['Developer', 'Superintendent', 'DeputySuperintendent'] }, ɵ7 = { roles: ['Developer', 'SystemAdmin', 'Cabinet'] };
var routes = [
    {
        path: 'offline',
        component: OfflineComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'actionneeded',
        component: ActionNeededComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'create',
        component: CreateComponent,
        canDeactivate: [UnsavedChangesGuard],
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'create/:RelatedRequestID',
        component: CreateComponent,
        canDeactivate: [UnsavedChangesGuard],
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'edit/:RequestID/:PreviousPage',
        component: EditRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'myrequests',
        component: RequestsComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'otherrequests',
        component: OtherRequestsComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'boardrequests',
        component: BoardRequestsComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'referrals',
        component: ReferralsComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'requestview/:RequestID',
        component: ViewRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'requestview/:RequestID/:PreviousPage',
        component: ViewRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'cabinetunassigned',
        component: CabinetUnassignedComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'handlerequest/:RequestID',
        component: HandleRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'handlerequest/:RequestID/:PreviousPage',
        component: HandleRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'handlerequest/:RequestID/:ReferralID/:PreviousPage',
        component: HandleRequestComponent,
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'search',
        component: SearchComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0,
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ1,
    },
    {
        path: 'categories',
        component: CategoriesComponent,
        canActivate: [AuthenticatedGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: ɵ2,
    },
    {
        path: 'emailpreferences',
        component: EmailPreferencesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ3,
    },
    {
        path: 'boardassistants',
        component: BoardAssistantsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ4,
    },
    {
        path: 'facilitators',
        component: FacilitatorsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ5,
    },
    {
        path: 'cabinetmembers',
        component: CabinetMembersComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ6,
    },
    {
        path: 'outofoffice',
        component: OutOfOfficeComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ7,
    },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
